var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-absolute tw-text-xl tw-text-yellow-300 tw-right-2 tw-bottom-2"},[_vm._v(" "+_vm._s(_vm.users.length)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }